/**
 * Created by hp on 2017/8/22.
 */
import React, {Component} from 'react';
import {Cell, CellBody, CellFooter} from 'react-weui';


class ComplainItem extends Component {
    render() {
        const {href, title, category} = this.props;
        if (category === 'product_feedback') {
            return (
                <Cell href='/specials/feedback' access>
                    <CellBody>{title}</CellBody>
                    <CellFooter/>
                </Cell>
            )
        }
        return (
            <Cell href={href} access>
                <CellBody>{title}</CellBody>
                <CellFooter/>
            </Cell>
        )
    }
}

export default ComplainItem;


// WEBPACK FOOTER //
// ./src/components/complain/ComplainItem.js